import { render, staticRenderFns } from "./SimulatorArmy.vue?vue&type=template&id=0831c24d&scoped=true&"
import script from "./SimulatorArmy.vue?vue&type=script&lang=js&"
export * from "./SimulatorArmy.vue?vue&type=script&lang=js&"
import style0 from "./SimulatorArmy.vue?vue&type=style&index=0&id=0831c24d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0831c24d",
  null
  
)

export default component.exports